/*
 * loading.tsx
 *
 * @Author: xiaoJQ
 * @Date: 2024-05-15 16:25:35
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
import React from 'react';
import { Spin } from '@kdcloudjs/kdesign';
import { useSelector } from 'store/hook/useSelector';
import S from './index.less';
export default function Loading() {
    var loadingProgress = useSelector(function (state) { return state.data; }).loadingProgress;
    return (React.createElement("div", { className: S.loading },
        React.createElement(Spin, null),
        React.createElement("span", { className: S.text }, loadingProgress)));
}
